import { VisitDocumentTemplateType } from '@dreryk/egabinet-visit-frontend-api';

import { assertUnreachable } from '@dreryk/react-common';

import { visitPaths } from '~libs.desktop.shared.paths';

import { getTemplateDraftId } from '../../visit.draft';

import { DocumentTemplateDraftName } from './DocumentTemplateAction.types';

const DOCUMENT_TEMPLATE_ROUTES = {
   MEDICAL_CERTIFICATE: visitPaths.getMedicalCertificatePath,
   REFERRAL_TO_ANALYTICAL_EXAMINATION: visitPaths.getReferralToAnalyticalExaminationPath,
   REFERRAL_TO_HOSPITAL: visitPaths.getReferralToHospitalPath,
   REFERRAL_TO_PSYCHIATRIC_HOSPITAL: visitPaths.getReferralToPsychiatricHospitalPath,
   REFERRAL_TO_DIAGNOSTIC_EXAMINATION: visitPaths.getReferralToDiagnosticExaminationPath,
   REFERRAL_TO_SPECIALIST: visitPaths.getReferralToSpecialistPath,
   REFERRAL_TO_REHABILITATION: visitPaths.getReferralToRehabilitationPath,
   DOCUMENT_TEMPLATE: visitPaths.getDocumentTemplatePath,
} as const;

export const selectDocumentTemplatePath = <TYPE extends VisitDocumentTemplateType>(
   type: TYPE,
   visitId: number,
   printTemplateId?: number
): string => {
   return DOCUMENT_TEMPLATE_ROUTES[type]({ params: { visitId: visitId, printTemplateId: printTemplateId } });
};

const getDraftTokenLastSegment = (draftToken: string): DocumentTemplateDraftName | null =>
   (draftToken.split('-').pop() as DocumentTemplateDraftName) ?? null;

export const getDocumentTemplateType = (draftToken: string): VisitDocumentTemplateType | null => {
   const lastSegment = getDraftTokenLastSegment(draftToken);
   const templateId = getTemplateDraftId(draftToken);
   if (!lastSegment || templateId !== null) {
      return null;
   }

   switch (lastSegment) {
      case 'medicalCertificate':
         return 'MEDICAL_CERTIFICATE';
      case 'referralToAnalyticalExamination':
         return 'REFERRAL_TO_ANALYTICAL_EXAMINATION';
      case 'referralToHospital':
         return 'REFERRAL_TO_HOSPITAL';
      case 'referralToRehabilitation':
         return 'REFERRAL_TO_REHABILITATION';
      case 'referralToDiagnosticExamination':
         return 'REFERRAL_TO_DIAGNOSTIC_EXAMINATION';
      case 'referralToPsychiatricHospital':
         return 'REFERRAL_TO_PSYCHIATRIC_HOSPITAL';
      case 'referralToSpecialist':
         return 'REFERRAL_TO_SPECIALIST';
      case 'documentTemplate':
         return null;
      default:
         return assertUnreachable(lastSegment);
   }
};
